import Route from "@ember/routing/route";
import { service } from "@ember/service";
import Organization from "glesys-controlpanel/models/organization";
import type AvailableServicesService from "glesys-controlpanel/services/available-services";

interface OrganizationRouteModel {
  organization: Organization;
}

export default class DatabasesRoute extends Route {
  @service declare availableServices: AvailableServicesService;

  beforeModel() {
    this.availableServices.requireAccessTo(this, "storage");
  }

  model(): OrganizationRouteModel {
    return this.modelFor("organization") as OrganizationRouteModel;
  }
}
